import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="wrapper">
        <div className="flex flex-col text-center md:text-left gap-4 mb-8 text-brand-ink/70">
          <p className="text-sm">{t('footer.credentials')}</p>
          <p className="text-sm">{t('footer.region')}</p>
          <p className="text-xs max-w-4xl mx-auto md:mx-0 opacity-70">
            {t('footer.disclaimer')}
          </p>
        </div>
        
        <div className="border-t border-brand-slate/10 pt-6 flex flex-col md:flex-row justify-between items-center text-brand-ink/70 text-sm">
          <p>&copy; {new Date().getFullYear()} Luara Rezende Advocacia. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;